module.exports = __webpack_public_path__ + "static/media/fb.bfc2fc8f.svg";